var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoto = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 24,
  fill: "none",
  viewBox: "0 0 22 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1.1 3.063a1.1 1.1 0 0 0-1.1 1.1v15.674a1.1 1.1 0 0 0 1.1 1.1h19.598a1.1 1.1 0 0 0 1.1-1.1V4.163a1.1 1.1 0 0 0-1.1-1.1zm.1 16.674v-7.551L4.926 8.46l11.277 11.277zM4.148 7.541 1.2 10.489V4.263h19.398v9.835l-2.144-2.143a1.1 1.1 0 0 0-1.555 0l-3.391 3.39-7.805-7.804a1.1 1.1 0 0 0-1.555 0m10.209 8.653 3.518 3.519-.024.024h2.747v-3.942l-2.921-2.921zm-.896-8.317a.871.871 0 1 1 1.742 0 .871.871 0 0 1-1.742 0m.871-2.072a2.071 2.071 0 1 0 0 4.143 2.071 2.071 0 0 0 0-4.143",
  clipRule: "evenodd"
})));
export { SvgPhoto as ReactComponent };